import styled, { css } from 'styled-components';
import { Headline3, Body6 } from './../../app/common/typography';

export const ContentArea = styled.div`
  margin-top: 88px;
  margin-bottom: 108px;
  margin-right: ${({ theme }) => theme.spacing.m};
  margin-left: ${({ theme }) => theme.spacing.m};
`;

export const ModalTitleContainer = styled.div`
  text-align: center;
`;

export const TitleAttachFileModal = styled(Headline3)`
  margin: ${({ theme }) => theme.spacing.md}
    ${({ theme }) => theme.spacing.none};
`;

export const RowContainer = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.md};
  margin-right: ${({ theme }) => theme.spacing.md};
  margin-bottom: ${({ theme }) => theme.spacing.s};
  margin-left: ${({ theme }) => theme.spacing.md};
`;

export const ColumHalf = styled.div`
  width: ${({ theme }) => theme.width.half};
`;

export const Borderbox = styled.div`
  border: 0.5px solid ${({ theme }) => theme.colors.platinum};
  border-radius: 6px;
`;

export const AddActionPlanForm = styled.table`
  width: 95%;
  padding: 10px;
  border-collapse: collapse;
  margin: ${({ theme }) => theme.spacing.none} auto;
`;

export const RequiredIcon = styled(Body6)`
  color: ${({ theme }) => theme.colors.redCrayola};
  display: inline;
`;

export const OwnerTable = styled.table``;

export const AssessmentTypeTable = styled.table`
  border-bottom: 0.5px solid #e1e1e1;
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const TextPill = styled.span`
  height: 25px;
  border-radius: 6px;
  text-align: center;
  display: block;
  background: #8ca7c4;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Table = styled.table`
  border-bottom: 0.5px solid #e1e1e1;
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const AddAttachmentsText = styled(Body6)`
  text-decoration-line: underline;
  color: ${({ theme }) => theme.colors.dimGray};
`;

export const GridContent = styled.div(
  ({ theme }) => css`
    padding-top: ${theme.spacing.m};
    display: grid;
    grid-template-columns: repeat(auto-fit, 30%);
    gap: ${theme.spacing.sm};
  `
);

export const GridItem = styled.div`
  border: ${({ theme }) => theme.colors.eerieBlack};
  text-align: center;
  border-radius: ${({ theme }) => theme.radius.m};
  display: flex;
  flex-wrap: wrap;
  position: relative;
`;

export const Thumbnail = styled.img`
  width: ${({ theme }) => theme.width.full};
  height: 100px;
  border-top-left-radius: ${({ theme }) => theme.radius.s};
  border-top-right-radius: ${({ theme }) => theme.radius.s};
  object-fit: cover;
`;

export const TitleContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s};
  align-items: baseline;
`;

export const FileNameContainer = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding: ${({ theme }) => theme.spacing.s};
  flex: 1;
  font-size: ${({ theme }) => theme.fontSize.s};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom-left-radius: ${({ theme }) => theme.radius.s};
  border-bottom-right-radius: ${({ theme }) => theme.radius.s};
`;

export const DeleteIconContainer = styled.div`
  position: absolute;
  right: ${({ theme }) => theme.spacing.xs};
  top: ${({ theme }) => theme.spacing.xs};
`;
